import { render } from "./OpenAiLogo.vue?vue&type=template&id=7c323d74"
import script from "./OpenAiLogo.vue?vue&type=script&lang=js"
export * from "./OpenAiLogo.vue?vue&type=script&lang=js"

import exportComponent from "/Users/georgwidschwendter/Documents/GitHub/learn/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__